// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-item {
        border: 1px solid rgb(29, 126, 236);
        cursor: pointer;
        padding: 2%;
        margin: 1% 0;
}

.label-value-container {
    border: 1px solid rgb(238, 195, 6);
    cursor: pointer;
    padding: 1%;
    margin: 2%;
    width: 100%;
}

.label-modal-container {
    height: 70%;
    overflow-y: scroll;
}

.sort-inp {
    /* border: 1px solid black; */
}

.sort-but {
    margin: 10px;
}

.fg-container {
    border: 1px solid rgb(29, 126, 236);
    width: 95%;
    margin: 2%;
    padding: 1%;
}

.single-filter-container {
    border: 1px solid rgb(77, 179, 9);
    width: 95%;
    margin: 2%;
    padding: 1%;
}

.sort-but-del {
    background: rgb(251, 136, 4);
}

.sort-but-edit {
    background: rgb(56, 126, 240);
    margin: 0 2%;
    color: white;
    font-weight: bold;
}

.val-but {
    margin: 2%;
    background: rgb(206, 202, 2);
    font-size: 15px;
}

.values-container {
    border: 1px solid rgb(226, 2, 58);
    width: 95%;
    margin: 2%;
    padding: 1%;
}

.delete-value-but {
    padding: 1% 2%;
    margin: 2%;
    background: rgb(172, 4, 4);
    border-radius: 20%;
    color: white;
    font-size: 20px;
}

.val-inp {
    margin: 2%;
}


.interstitial-filters {
    margin-top: 20px;
}
  
.interstitial-filters-radio {
    padding-right: 10px;
    margin-right: 0px !important;
}
.radio-label-text {
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./client/components/dashboard/SortnFilter/sortnfilter.css"],"names":[],"mappings":"AAAA;QACQ,mCAAmC;QACnC,eAAe;QACf,WAAW;QACX,YAAY;AACpB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,WAAW;IACX,UAAU;IACV,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,UAAU;IACV,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,UAAU;IACV,UAAU;IACV,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,UAAU;IACV,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;IACd,UAAU;IACV,0BAA0B;IAC1B,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".label-item {\n        border: 1px solid rgb(29, 126, 236);\n        cursor: pointer;\n        padding: 2%;\n        margin: 1% 0;\n}\n\n.label-value-container {\n    border: 1px solid rgb(238, 195, 6);\n    cursor: pointer;\n    padding: 1%;\n    margin: 2%;\n    width: 100%;\n}\n\n.label-modal-container {\n    height: 70%;\n    overflow-y: scroll;\n}\n\n.sort-inp {\n    /* border: 1px solid black; */\n}\n\n.sort-but {\n    margin: 10px;\n}\n\n.fg-container {\n    border: 1px solid rgb(29, 126, 236);\n    width: 95%;\n    margin: 2%;\n    padding: 1%;\n}\n\n.single-filter-container {\n    border: 1px solid rgb(77, 179, 9);\n    width: 95%;\n    margin: 2%;\n    padding: 1%;\n}\n\n.sort-but-del {\n    background: rgb(251, 136, 4);\n}\n\n.sort-but-edit {\n    background: rgb(56, 126, 240);\n    margin: 0 2%;\n    color: white;\n    font-weight: bold;\n}\n\n.val-but {\n    margin: 2%;\n    background: rgb(206, 202, 2);\n    font-size: 15px;\n}\n\n.values-container {\n    border: 1px solid rgb(226, 2, 58);\n    width: 95%;\n    margin: 2%;\n    padding: 1%;\n}\n\n.delete-value-but {\n    padding: 1% 2%;\n    margin: 2%;\n    background: rgb(172, 4, 4);\n    border-radius: 20%;\n    color: white;\n    font-size: 20px;\n}\n\n.val-inp {\n    margin: 2%;\n}\n\n\n.interstitial-filters {\n    margin-top: 20px;\n}\n  \n.interstitial-filters-radio {\n    padding-right: 10px;\n    margin-right: 0px !important;\n}\n.radio-label-text {\n    margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
